export const CANVAS_MIGRATION_PATH = '/canvas-migration'

export const isCanvasMigrationPath = (pathname: string): boolean => {
  const path = (pathname || '').split('?')[0].split('#')[0]
  return (
    path === CANVAS_MIGRATION_PATH ||
    path.startsWith(`${CANVAS_MIGRATION_PATH}/`)
  )
}

export const isLabraHomeOverviewPath = (pathname: string): boolean => {
  const path = ((pathname || '').split('?')[0].split('#')[0] || '/').replace(
    /\/+$/,
    ''
  )

  if (path === '/overview' || path.startsWith('/overview/')) {
    return true
  }

  if (
    path === '/dashboard/overview' ||
    path.startsWith('/dashboard/overview/')
  ) {
    return true
  }

  return /^\/dashboard\/[^/]+\/[^/]+\/overview(?:\/.*)?$/.test(path)
}

export const shouldHideAppChromeForCanvasMigration = ({
  isMigrationActive,
  pathname,
}: {
  isMigrationActive: boolean
  pathname: string
}): boolean =>
  isMigrationActive &&
  (isCanvasMigrationPath(pathname) || isLabraHomeOverviewPath(pathname))
